import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { RouterModule } from "@angular/router"
import { JourneyDoorUnlockCasesDialogComponent } from "./dialogs/journey-door-unlock-cases-dialog/journey-door-unlock-cases-dialog.component"
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatAutocompleteModule } from "@angular/material/autocomplete"
import { MatButtonModule } from "@angular/material/button"
import { MatButtonToggleModule } from "@angular/material/button-toggle"
import { MatCheckboxModule } from "@angular/material/checkbox"
import { MatDatepickerModule } from "@angular/material/datepicker"
import { MatDialogModule } from "@angular/material/dialog"
import { MatExpansionModule } from "@angular/material/expansion"
import { MatIconModule } from "@angular/material/icon"
import { MatInputModule } from "@angular/material/input"
import { MatTooltipModule } from "@angular/material/tooltip"
import { MatMenuModule } from "@angular/material/menu"
import { MatPaginatorModule } from "@angular/material/paginator"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import { MatRadioModule } from "@angular/material/radio"
import { MatSelectModule } from "@angular/material/select"
import { MatSlideToggleModule } from "@angular/material/slide-toggle"
import { MatSortModule } from "@angular/material/sort"
import { MatTabsModule } from "@angular/material/tabs"
import { MatBadgeModule } from "@angular/material/badge"
import { MAT_MOMENT_DATE_FORMATS, MatMomentDateModule } from "@angular/material-moment-adapter"
import { ToastComponent } from "app/toast/toast.component"
import { CombineFullNamePipe } from "app/shared/pipes/combine-fullname.pipe"
import { SafeHtmlPipe } from "app/shared/pipes/safehtml.pipe"
import { ImageComponent } from "./components/image/image.component"
import { ImageUploadComponent } from "./components/image-upload/image-upload.component"
import { MaterialDateAdapter } from "app/shared/MaterialDateAdapter"
import { HeaderComponent } from "./components/header/header.component"
import { JoyrideModule } from "ngx-joyride"
import { TooltipService } from "app/shared/services/tooltip.service"
import { TooltipDirective } from "app/shared/components/tooltip/tooltip.directive"
import { TooltipContentComponent } from "app/shared/components/tooltip/tooltip.component"
import { TooltipContainerComponent } from "app/shared/components/tooltip/tooltip-container.component"
import { QuickActionService } from "./services/quick-action.service"
import { QuickActionDirective } from "./components/quick-action/quick-action.directive"
import { QuickActionComponent } from "./components/quick-action/quick-action.component"
import { QuickActionContainerComponent } from "./components/quick-action/quick-action-container.component"
import { ImageWithCameraComponent } from "./components/image-with-camera/image-with-camera.component"
import { ImageUploadHoverComponent } from "./components/image-upload-hover/image-upload-hover.component"
import { QuillModule } from "ngx-quill"
import { ColorPickerModule } from "ngx-color-picker"
import { ConcatenateStringArrayPipe } from "app/shared/pipes/concatenate-string-array.pipe"
import { RefundDialogComponent } from "./dialogs/refund-dialog/refund-dialog.component"
import { ChargeDialogComponent } from "./dialogs/charge-dialog/charge-dialog.component"
import { ChargeBillDialogComponent } from "./dialogs/charge-bill-dialog/charge-bill-dialog.component"
import { SmoothHeightComponent } from "./animations/smooth-height.component"
import { DeletableItemListComponent } from "./animations/deletable-item-list.component"
import { CurrencyFieldComponent } from "./animations/currency-field.component"
import { SearchBoxComponent } from "./animations/search-box.component"
import { GlobalLoaderComponent } from "./animations/global-loader.component"
import { CircleLoaderComponent } from "./animations/circle-loader.component"
import { DropDownListComponent } from "./animations/drop-down-list"
import { RoundButtonComponent } from "./components/round-button"
import { ImageBrowserComponent } from "./animations/image-browser.component"
import { DragDropModule } from "@angular/cdk/drag-drop"
import { NavMenuHotelsListDropdownComponent } from "./animations/list-dropdown-animation"
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap"
import { NgxSliderModule } from "@angular-slider/ngx-slider"
import { PaymentRulesService } from "app/property-setup/revenue/payment-rules/payment-rules.service"
import { SaveButton2Component } from "./animations/save-button2.component"
import { NgCircleProgressModule } from "ng-circle-progress"
import { ColumnTemplateComponent } from "./components/column-template/column-template.component"
import { BasicSetupService } from "app/property-setup/revenue/basic-setup/basic-setup.service"
import { MobileTemplateComponent } from "./components/mobile-template/mobile-template.component"
import { JourneyProgressWheelComponent } from "./components/journey-progress-wheel/journey-progress-wheel.component"
import { ChargePreAuthDialogComponent } from "./dialogs/charge-pre-auth-dialog/charge-pre-auth-dialog.component"
import { ReleaseDialogComponent } from "./dialogs/release-dialog/release-dialog.component"
import { LabeledTextFieldComponent } from "./animations/labeled-text-field.component"
import { DotLoaderWhiteAnimationComponent } from "./animations/dot-loader-white-animation"
import { LottieComponent, provideLottieOptions } from "ngx-lottie"
import player from "lottie-web"
import { AgSectionComponent } from "./layout/ag-section/ag-section.component"
import { AgSectionV2Component } from "./layout/ag-section/ag-sectionv2.component"
import { OverlayFullscreenBoxComponent } from "./layout/overlay-fullscreen-box/overlay-fullscreen-box.component"
import { MatTableModule } from "@angular/material/table"
import { AgTextSwitchComponent } from "./components/form-controls/ag-text-switch/ag-text-switch.component"
import { AgInputComponent } from "./components/form-controls/ag-input/ag-input.component"
import { AgInputV2Component } from "./components/form-controls/ag-input-v2/ag-input-v2.component"
import { AgInputCurrencyComponent } from "./components/form-controls/ag-input-currency/ag-input-currency.component"
import { AgInputCurrencyV2Component } from "./components/form-controls/ag-input-currency-v2/ag-input-currency-v2.component"
import { AgTooltipComponent } from "./components/form-controls/ag-tooltip/ag-tooltip.component"
import { AgTooltipDirective } from "./components/form-controls/ag-tooltip/ag-tooltip.directive"
import { AgTimeComponent } from "./components/form-controls/ag-time/ag-time.component"
import { AgOpeningHoursComponent } from "./components/form-controls/ag-opening-hours/ag-opening-hours.component"
import { AgRadioGroupComponent } from "./components/form-controls/ag-radio-group/ag-radio-group.component"
import { AgSelectComponent } from "./components/form-controls/ag-select/ag-select.component"
import { CurrencyService } from "./services/currency.service"
import { AgReportComponent } from "./components/ag-report/ag-report.component"
import { AgReportMessageComponent } from "./components/ag-report/ag-report-message/ag-report-message.component"
import { AgTextareaComponent } from "./components/form-controls/ag-textarea/ag-textarea.component"
import { AgInputPercentageComponent } from "./components/form-controls/ag-input-percentage/ag-input-percentage.component"
import { AgButtonComponent } from "./components/ag-button/ag-button.component"
import { AgSignatureComponent } from "./components/form-controls/ag-signature/ag-signature.component"
import { AgCheckboxComponent } from "./components/form-controls/ag-checkbox/ag-checkbox.component"
import { AgTreeModule } from "./layout/ag-tree/ag-tree.module"
import { AgTreeV2Module } from "./layout/ag-tree-v2/ag-tree-v2.module"
import { AgDurationComponent } from "./components/form-controls/ag-duration/ag-duration.component"
import { AgButtonSliderComponent } from "./animations/ag-button-slider-component"
import { DataDisplayIconComponent } from "./components/data-display-icon/data-display-icon.component"
import { SortDirectBookingsItemsPipe } from "./pipes/sort-direct-bookings-items.pipe"
import { SearchBoxV2Component } from "./animations/search-box-v2.component"
import { RoundDropDownListV2Component } from "./animations/round-drop-down-list-v2"
import { AscDescIconComponent } from "./components/asc-desc-icon/asc-desc-icon.component"
import { AgButtonV2Component } from "./components/ag-button-v2/ag-button-v2.component"
import { AgLabelComponent } from "./components/ag-label/ag-label.component"
import { NewInfoboxComponent } from "./components/new-infobox/new-infobox.component"
import { FixedBottomBarComponent } from "./components/fixed-bottom-bar/fixed-bottom-bar.component"
import { ToastV2Component } from "./services/toast-v2/toast-v2.component"
import { AgBreadcrumbComponent } from "./components/ag-breadcrumb/ag-breadcrumb.component"
import { AgCheckboxV2Component } from "./components/ag-checkbox-v2/ag-checkbox-v2.component"
import { RoundDropDownListV3Component } from "./animations/round-drop-down-list-v3"
import { SearchBoxV3Component } from "./animations/search-box-v3.component"
import { DatePickerComponent } from "./animations/datePicker-component"
import { CountryCodePickerComponent } from "./animations/country-code-picker-component"
import { FilterCountryCodes } from "./pipes/search-country-codes.pipe"
import { AgToggleSwitchComponent } from "./components/ag-toggle-switch/ag-toggle-switch.component"
import { IconImageService } from "./services/icon-image.service"
import { AgTextareaV2Component } from "./components/ag-textarea/ag-textarea.component"
import { AgInputFieldComponent } from "./components/ag-input-field/ag-input-field.component"
import { AgTooltipV2Component } from "./components/ag-tooltip-v2/ag-tooltip-v2.component"
import { AgTooltipDirectiveV2 } from "./components/ag-tooltip-v2/ag-tooltip-v2.directive"
import { ClickOutsideDirective } from "./directives/clickOutside.directive"
import { AutoGrowTextareaDirective } from "./directives/auto-grow-textarea.directive"
import { ImageLoaderDirective } from "./directives/image-loader.directive"
import { AgTooltipContainerV2Component } from "./components/ag-tooltip-v2/ag-tooltip-v2-container.component"
import { AgSearchBarComponent } from "./components/ag-search-bar/ag-search-bar.component"
import { AgTagsInputComponent } from "./components/ag-tags-input/ag-tags-input.component"
import { AgCountryCodeBoxComponent } from "./components/ag-drop-down/ag-country-code-box/ag-country-code-box.component"
import { AgMultipleBoxComponent } from "./components/ag-drop-down/ag-multiple-box/ag-multiple-box.component"
import { AgSingleBoxComponent } from "./components/ag-drop-down/ag-single-box/ag-single-box.component"
import { AgSingleSubLabelBoxComponent } from "./components/ag-drop-down/ag-single-sublabel-box/ag-single-sublabel-box.component"
import { AgSingleDescriptionBoxComponent } from "./components/ag-drop-down/ag-single-description-box/ag-single-description-box.component"

import { AgDropDownComponent } from "./components/ag-drop-down/ag-drop-down.component"
import { AgRightCheckMarkBoxComponent } from "./components/ag-drop-down/ag-right-checkmark-box/ag-right-checkmark-box.component"
import { AgFilterDropDownComponent } from "./components/ag-filter-drop-down/ag-filter-drop-down.component"
import { MediaLibraryDragImageDirective } from "./animations/media-library-drag-image.directive"
import { AgToggleButtonComponent } from "./components/ag-toggle-button/ag-toggle-button.component"
import { AgMultipleSectionBoxComponent } from "./components/ag-drop-down/ag-multiple-section-box/ag-multiple-section-box.component"
import { AgConfirmDialogComponent } from "./dialogs/ag-confirm-dialog/ag-confirm-dialog.component"
import { DynamicVariableDialogComponent } from "./dialogs/dynamic-variable-dialog/dynamic-variable-dialog.component"
import { BarLoaderComponent } from "./components/bar-loader/bar-loader.component"
import { AgDatePickerComponent } from "./components/ag-date-picker/ag-date-picker.component"
import { DateRegularBoxComponent } from "./components/ag-date-picker/date-regular-box/date-regular-box.component"
import { DateDoubleBoxComponent } from "./components/ag-date-picker/date-double-box/date-double-box.component"
import { DateMonthBoxComponent } from "./components/ag-date-picker/date-month-box/date-month-box.component"
import { SearchNameFilterPipe } from "./pipes/name-filter.pipe"
import { ConditionTextSegmentsPipe } from "./pipes/condition-text-segments.pipe"
import { AgCounterFieldComponent } from "./components/ag-counter-field/ag-counter-field.component"
import { ImageAdjustDialogComponent } from "./dialogs/image-adjust-dialog/image-adjust-dialog.component"
import { AutoSignOutService } from "./services/auto-signout.service"
import { AgCommunicationLanguageComponent } from "./components/ag-communication-language/ag-communication-language.component"
import { AgIconTextBoxComponent } from "./components/ag-drop-down/ag-icon-text-box/ag-icon-text-box.component"
import { AgAvatarComponent } from "./components/ag-avatar/ag-avatar.component"
import { AgDividerComponent } from "./components/ag-divider/ag-divider.component"
import { AgTabComponent } from "./components/ag-tab/ag-tab.component"
import { AgNotificationBadgeComponent } from "./components/ag-notification-badge/ag-notification-badge.component"
import { ConfirmDownloadDialogComponent } from "./dialogs/confirm-download-dialog/confirm-download-dialog.component"
import { AgFilterDialogComponent } from "./dialogs/ag-filter-dialog/ag-filter-dialog.component"
import { IllustrationDialogComponent } from "./dialogs/illustration-dialog/illustration-dialog.component"
import { AgToggleButtonImgComponent } from "./components/ag-toggle-button-img/ag-toggle-button-img.component"
import { FlowButtonComponent } from "./components/flow-button/flow-button.component"
import { ColorPaletteService } from "./services/color-palette.service"
import { AgCheckboxBoxComponent } from "./components/ag-drop-down/ag-checkbox-box/ag-checkbox-box.component"
import { FlowBadgeComponent } from "./components/flow-badge/flow-badge.component"
import { FlowAccordionComponent } from "./components/flow-accordion-container/flow-accordion/flow-accordion.component"
import { FlowAccordionContainerComponent } from "./components/flow-accordion-container/flow-accordion-container.component"
import { FlowTabComponent } from "./components/flow-tab/flow-tab.component"
import { FlowCheckboxComponent } from "./components/flow-checkbox/flow-checkbox.component"
import { FlowDividerComponent } from "./components/flow-divider/flow-divider.component"
import { FlowCardComponent } from "./components/flow-card/flow-card.component"
import { BiggerImageDialogComponent } from "./dialogs/bigger-image-dialog/bigger-image-dialog.component"
import { AgAddIconLibComponent } from "./components/ag-add-icon-lib/ag-add-icon-lib.component"
import { AgAdjustImageComponent } from "./components/ag-adjust-image/ag-adjust-image.component"
import { AgConditionalDialogComponent } from "./dialogs/ag-conditional-dialog/ag-conditional-dialog.component"
import { FlowConfirmDialogComponent } from "./dialogs/flow-confirm-dialog/flow-confirm-dialog.component"
import { AgTextDirective } from "./directives/ag-text.directive"
import { FlowLoaderComponent } from "./components/flow-loader/flow-loader.component"
import { FlowHelperTextComponent } from "./components/flow-helper-text/flow-helper-text.component"
import { FlowSwitchComponent } from "./components/flow-switch/flow-switch.component"
import { FlowPillComponent } from "./components/flow-pill/flow-pill.component"
import { FlowSegmentControlComponent } from "./components/flow-segment-control/flow-segment-control.component"
import { FlowBadgeV2Component } from "./components/flow-badge-v2/flow-badge-v2.component"
import { FlowButtonV2Component } from "./components/flow-button-v2/flow-button-v2.component"
import { FlowCheckboxV2Component } from "./components/flow-checkbox-v2/flow-checkbox-v2.component"
import { FlowSearchInputComponent } from "./components/flow-search-input/flow-search-input.component"
import { FlowTextInputComponent } from "./components/flow-text-input/flow-text-input.component"
import { FlowCardV2Component } from "./components/flow-card-v2/flow-card-v2.component"
import { FlowDropDownItemComponent } from "./components/flow-drop-down/flow-drop-down-item/flow-drop-down-item.component"
import { FlowDropDownComponent } from "./components/flow-drop-down/flow-drop-down.component"
import { FlowSelectComponent } from "./components/flow-select/flow-select.component"
import { FlowChipComponent } from "./components/flow-chip/flow-chip.component"

export function playerFactory() {
  return player
}

@NgModule({
  declarations: [
    JourneyDoorUnlockCasesDialogComponent,
    ToastComponent,
    SafeHtmlPipe,
    CombineFullNamePipe,
    ImageComponent,
    ImageWithCameraComponent,
    ImageUploadComponent,
    HeaderComponent,
    TooltipDirective,
    TooltipContentComponent,
    TooltipContainerComponent,
    QuickActionDirective,
    QuickActionComponent,
    QuickActionContainerComponent,
    ImageUploadHoverComponent,
    ConcatenateStringArrayPipe,
    RefundDialogComponent,
    ImageAdjustDialogComponent,
    BiggerImageDialogComponent,
    ChargeDialogComponent,
    ChargeBillDialogComponent,
    SmoothHeightComponent,
    NavMenuHotelsListDropdownComponent,
    DeletableItemListComponent,
    CurrencyFieldComponent,
    SearchBoxComponent,
    SearchBoxV2Component,
    SearchBoxV3Component,
    GlobalLoaderComponent,
    CircleLoaderComponent,
    DropDownListComponent,
    RoundDropDownListV2Component,
    RoundDropDownListV3Component,
    RoundButtonComponent,
    ImageBrowserComponent,
    MediaLibraryDragImageDirective,
    SaveButton2Component,
    ColumnTemplateComponent,
    MobileTemplateComponent,
    JourneyProgressWheelComponent,
    ChargePreAuthDialogComponent,
    LabeledTextFieldComponent,
    ReleaseDialogComponent,
    ConfirmDownloadDialogComponent,
    DotLoaderWhiteAnimationComponent,
    AgSectionComponent,
    AgSectionV2Component,
    DataDisplayIconComponent,
    OverlayFullscreenBoxComponent,
    AgTextSwitchComponent,
    AgInputComponent,
    AgDurationComponent,
    AgInputCurrencyComponent,
    AgInputCurrencyV2Component,
    AgTooltipComponent,
    AgTooltipDirective,
    AgTimeComponent,
    AgOpeningHoursComponent,
    AgRadioGroupComponent,
    AgSelectComponent,
    AgReportComponent,
    AgReportMessageComponent,
    AgTextareaComponent,
    AgInputPercentageComponent,
    AgButtonComponent,
    AgButtonV2Component,
    AgAvatarComponent,
    AgLabelComponent,
    AgSignatureComponent,
    AgCheckboxComponent,
    AgButtonSliderComponent,
    SortDirectBookingsItemsPipe,
    AscDescIconComponent,
    NewInfoboxComponent,
    FixedBottomBarComponent,
    AgInputV2Component,
    ToastV2Component,
    AgBreadcrumbComponent,
    AgCheckboxV2Component,
    DatePickerComponent,
    AgDatePickerComponent,
    DateRegularBoxComponent,
    DateDoubleBoxComponent,
    DateMonthBoxComponent,
    CountryCodePickerComponent,
    FilterCountryCodes,
    AgToggleSwitchComponent,
    AgToggleButtonComponent,
    AgTextareaV2Component,
    AgInputFieldComponent,
    AgCounterFieldComponent,
    AgTooltipDirectiveV2,
    ClickOutsideDirective,
    AutoGrowTextareaDirective,
    ImageLoaderDirective,
    AgTooltipV2Component,
    AgTooltipContainerV2Component,
    AgSearchBarComponent,
    AgCountryCodeBoxComponent,
    AgMultipleBoxComponent,
    AgCheckboxBoxComponent,
    AgSingleBoxComponent,
    AgSingleSubLabelBoxComponent,
    AgSingleDescriptionBoxComponent,
    AgIconTextBoxComponent,
    AgMultipleSectionBoxComponent,
    AgDropDownComponent,
    AgRightCheckMarkBoxComponent,
    AgFilterDropDownComponent,
    AgTagsInputComponent,
    AgConfirmDialogComponent,
    DynamicVariableDialogComponent,
    BarLoaderComponent,
    SearchNameFilterPipe,
    ConditionTextSegmentsPipe,
    AgCommunicationLanguageComponent,
    AgDividerComponent,
    AgTabComponent,
    AgNotificationBadgeComponent,
    AgFilterDialogComponent,
    IllustrationDialogComponent,
    AgToggleButtonImgComponent,
    FlowBadgeComponent,
    FlowButtonComponent,
    FlowCardComponent,
    FlowAccordionComponent,
    FlowAccordionContainerComponent,
    FlowTabComponent,
    FlowCheckboxComponent,
    FlowDividerComponent,
    AgAddIconLibComponent,
    AgAdjustImageComponent,
    AgConditionalDialogComponent,
    FlowConfirmDialogComponent,
    AgTextDirective,
    FlowLoaderComponent,
    FlowHelperTextComponent,
    FlowSwitchComponent,
    FlowPillComponent,
    FlowSegmentControlComponent,
    FlowBadgeV2Component,
    FlowButtonV2Component,
    FlowCheckboxV2Component,
    FlowSearchInputComponent,
    FlowTextInputComponent,
    FlowCardV2Component,
    FlowDropDownItemComponent,
    FlowDropDownComponent,
    FlowSelectComponent,
    FlowChipComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ColorPickerModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatPaginatorModule,
    MatTabsModule,
    MatMenuModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatSortModule,
    MatTableModule,
    MatDatepickerModule,
    MatBadgeModule,
    MatMomentDateModule,
    RouterModule,
    DragDropModule,
    QuillModule,
    JoyrideModule.forRoot(),
    NgbTooltipModule,
    NgxSliderModule,
    AgTreeModule,
    AgTreeV2Module,
    LottieComponent,
    NgCircleProgressModule.forRoot({
      radius: 15,
      showUnits: false,
      showTitle: false,
      showSubtitle: false,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 0,
      animation: false,
      space: -4,
      lazy: false,
    }),
  ],
  exports: [
    CommonModule,
    ColorPickerModule,
    ConcatenateStringArrayPipe,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatButtonModule,
    SafeHtmlPipe,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatTabsModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatTableModule,
    ToastComponent,
    ToastV2Component,
    CombineFullNamePipe,
    ImageComponent,
    ImageWithCameraComponent,
    ImageUploadComponent,
    HeaderComponent,
    TooltipDirective,
    TooltipContentComponent,
    TooltipContainerComponent,
    AgTooltipDirectiveV2,
    ClickOutsideDirective,
    AutoGrowTextareaDirective,
    ImageLoaderDirective,
    AgTooltipV2Component,
    AgTooltipContainerV2Component,
    QuickActionDirective,
    QuickActionComponent,
    QuickActionContainerComponent,
    MatSortModule,
    JoyrideModule,
    ImageUploadHoverComponent,
    ImageUploadHoverComponent,
    QuillModule,
    SmoothHeightComponent,
    NavMenuHotelsListDropdownComponent,
    DeletableItemListComponent,
    CurrencyFieldComponent,
    SearchBoxComponent,
    SearchBoxV2Component,
    SearchBoxV3Component,
    GlobalLoaderComponent,
    CircleLoaderComponent,
    DropDownListComponent,
    RoundDropDownListV2Component,
    RoundDropDownListV3Component,
    RoundButtonComponent,
    ImageBrowserComponent,
    DragDropModule,
    MediaLibraryDragImageDirective,
    SaveButton2Component,
    NgCircleProgressModule,
    ColumnTemplateComponent,
    MobileTemplateComponent,
    JourneyProgressWheelComponent,
    LabeledTextFieldComponent,
    DotLoaderWhiteAnimationComponent,
    AgSectionComponent,
    AgSectionV2Component,
    DataDisplayIconComponent,
    AgButtonSliderComponent,
    OverlayFullscreenBoxComponent,
    AgTextSwitchComponent,
    AgInputComponent,
    AgInputV2Component,
    AgDurationComponent,
    AgInputCurrencyComponent,
    AgInputCurrencyV2Component,
    AgTimeComponent,
    AgOpeningHoursComponent,
    AgRadioGroupComponent,
    AgSelectComponent,
    AgReportComponent,
    AgReportMessageComponent,
    AgTextareaComponent,
    AgInputPercentageComponent,
    AgButtonComponent,
    AgButtonV2Component,
    AgAvatarComponent,
    AgLabelComponent,
    AgSignatureComponent,
    AgCheckboxComponent,
    AgTreeModule,
    AgTreeV2Module,
    SortDirectBookingsItemsPipe,
    AscDescIconComponent,
    NewInfoboxComponent,
    FixedBottomBarComponent,
    AgBreadcrumbComponent,
    AgCheckboxV2Component,
    DatePickerComponent,
    AgDatePickerComponent,
    DateRegularBoxComponent,
    DateDoubleBoxComponent,
    DateMonthBoxComponent,
    CountryCodePickerComponent,
    FilterCountryCodes,
    AgToggleSwitchComponent,
    AgToggleButtonComponent,
    AgTextareaV2Component,
    AgInputFieldComponent,
    AgCounterFieldComponent,
    AgSearchBarComponent,
    AgCountryCodeBoxComponent,
    AgMultipleBoxComponent,
    AgCheckboxBoxComponent,
    AgSingleBoxComponent,
    AgSingleSubLabelBoxComponent,
    AgSingleDescriptionBoxComponent,
    AgIconTextBoxComponent,
    AgMultipleSectionBoxComponent,
    AgDropDownComponent,
    AgRightCheckMarkBoxComponent,
    AgFilterDropDownComponent,
    AgTagsInputComponent,
    AgConfirmDialogComponent,
    ConfirmDownloadDialogComponent,
    DynamicVariableDialogComponent,
    BarLoaderComponent,
    SearchNameFilterPipe,
    ConditionTextSegmentsPipe,
    LottieComponent,
    AgCommunicationLanguageComponent,
    AgDividerComponent,
    AgTabComponent,
    AgNotificationBadgeComponent,
    IllustrationDialogComponent,
    AgToggleButtonImgComponent,
    FlowBadgeComponent,
    FlowButtonComponent,
    FlowCardComponent,
    FlowAccordionComponent,
    FlowAccordionContainerComponent,
    FlowTabComponent,
    FlowCheckboxComponent,
    FlowDividerComponent,
    AgAddIconLibComponent,
    AgAdjustImageComponent,
    AgConditionalDialogComponent,
    FlowConfirmDialogComponent,
    AgTextDirective,
    FlowLoaderComponent,
    FlowHelperTextComponent,
    FlowSwitchComponent,
    FlowPillComponent,
    FlowSegmentControlComponent,
    FlowBadgeV2Component,
    FlowButtonV2Component,
    FlowCheckboxV2Component,
    FlowSearchInputComponent,
    FlowTextInputComponent,
    FlowCardV2Component,
    FlowDropDownItemComponent,
    FlowDropDownComponent,
    FlowSelectComponent,
    FlowChipComponent,
  ],
  providers: [
    QuickActionService,
    TooltipService,
    ConcatenateStringArrayPipe,
    SearchNameFilterPipe,
    CombineFullNamePipe,
    BasicSetupService,
    PaymentRulesService,
    CurrencyService,
    AgTooltipDirective,
    IconImageService,
    FilterCountryCodes,
    AutoSignOutService,
    ColorPaletteService,
    provideLottieOptions({ player: playerFactory }),
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    {
      provide: DateAdapter,
      useClass: MaterialDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
